import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
	providedIn: "root",
})
export class HttpErrorInterceptor implements HttpInterceptor {
	private errorHandler = inject(ErrorHandlerService);

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Tracking the request source
		const source = this.extractSourceFromUrl(request.url);

		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				// Only handle HttpErrorResponses
				if (error instanceof HttpErrorResponse) {
					const context = {
						source,
						action: request.method,
						data: {
							url: request.url,
							body: request.body,
						},
					};

					// Special cases for specific errors
					if (error.status === 401) {
						// Return the error through the handler which will redirect to login
						return this.errorHandler.handleHttpError(error, {
							...context,
							action: "AUTHENTICATION",
						});
					}

					// Rate limiting
					if (error.status === 429) {
						return this.errorHandler.handleHttpError(error, {
							...context,
							action: "RATE_LIMIT_EXCEEDED",
						});
					}

					// General error handling
					return this.errorHandler.handleHttpError(error, context);
				}

				// For non-HTTP errors, just rethrow
				return throwError(() => error);
			}),
		);
	}

	/**
	 * Extract a meaningful source name from the API URL
	 */
	private extractSourceFromUrl(url: string): string {
		try {
			// Try to parse the URL to get the API endpoint
			const urlObj = new URL(url);
			const pathParts = urlObj.pathname.split("/").filter(Boolean);

			// Use the API endpoint as source
			if (pathParts.length > 0) {
				// Take the first meaningful part after the API base
				return pathParts.slice(0, 2).join("/");
			}

			return "api-call";
		} catch (e) {
			// If URL parsing fails, return a generic source
			return "http-request";
		}
	}
}
